import React from 'react';

import CheckIllustrationIcon from '../../assets/svg-components/check_icon.svg';
import copyToClipboard from '../../utils/copy-to-clipboard';
import { Button } from '../button/button';
import { Context } from '../context/context';
import { Translate } from '../translate';
import './share-box.scss';

const ShareBox = () => {
  const { device } = React.useContext(Context);
  const [isActive, setIsActive] = React.useState(false);

  const url = location.origin + location.pathname + location.search;

  const handleClick = () => {
    setIsActive(true);
    setTimeout(() => {
      setIsActive(false);
    }, 1000);

    copyToClipboard(url);
  };
  return (
    <React.Fragment>
      <div className="bd-share-box__container" data-component="share-box">
        <p className="bd-share-box__text">{url}</p>
        {!device.isPhone && (
          <div className="bd-share-box__copy-desktop">
            <div className="bd-share-box__separator"></div>
            {isActive ? (
              <div className="bd-share-box__copied-link">
                <CheckIllustrationIcon width={16} height={16} />
                <Translate id="translate.share.dialog.url.copied" />
              </div>
            ) : (
              <div className="bd-share-box__copy-link" onClick={handleClick}>
                <Translate id="translate.share.dialog.copy.url" />
              </div>
            )}
          </div>
        )}
      </div>
      {device.isPhone && (
        <Button size="medium" onClick={handleClick}>
          {isActive ? (
            <div className="bd-share-box__copy-phone">
              <CheckIllustrationIcon width={16} height={16} fill="white" />
              <Translate id="translate.share.dialog.url.copied" />
            </div>
          ) : (
            <div>
              <Translate id="translate.share.dialog.copy.url" />
            </div>
          )}
        </Button>
      )}
    </React.Fragment>
  );
};

export default ShareBox;
